import React, { Component } from 'react'
import { withStyles } from '@material-ui/styles'
import { TipForm } from '../forms'
import { Dashboard } from '../layouts'

const styles = theme => ({
    //
})

class TipNew extends Component {
    constructor(props) {
        super(props)
        
        this.state = {
            title: 'Tips'
        }
    }

    render() {
        const { title } = this.state
        return (
            <Dashboard title={title}>
                <TipForm 
                    path="tips"
                    method="post"
                    message="Амжилттай нэмэгдлээ"
                />
            </Dashboard>
        )
    }
}

export default withStyles(styles)(TipNew)
